<template>
  <div class="group-root" :class="{ root }">
    <div class="name" :class="{ 'root': root, 'selected': isSelected }" @click="toggleOpen">
      <i v-if="!open && group.subGroups && group.subGroups.length" class="fas fa-plus-circle icon-show-details" :title="title"></i>
      <i v-if="open && group.subGroups && group.subGroups.length" class="fas fa-minus-circle icon-show-details" :title="title"></i>
      <div @dblclick.stop="$emit('select-open', group)" @click.stop="$emit('select', group)" :title="titleSelect">
            <div class="group-title">
              <h6>{{ group.name }}</h6><small> (ID: {{ group.id }})</small>
              <span v-if="group.status ===  groupStatus.INACTIVE" class="status__badge badge badge-danger ml-1">Inactivo</span>
            </div>
            <div class="group-details">
              <div class="group-details__related-recodrs small">
                <div class="text-truncate" :title="subGroupsList">
                  <i class="fas fa-users-class"></i>: {{ subGroupsList.length ? subGroupsList : '---' }}</div>
                <div class="text-truncate" :title="usersList">
                  <i class="fas fa-users"></i>: {{ usersList.length ? usersList : '---' }}</div>
                <div class="text-truncate" :title="projectsList">
                  <i class="fas fa-folders"></i>: {{ projectsList.length ? projectsList : '---' }}</div>
              </div>
              <div class="group-details__dates small">
                <div>
                  Fecha de creación: {{ creationDate }}
                </div>
                <div>
                  Fecha de actualización: {{ updateDate }}
                </div>
              </div>
            </div>
      </div>
    </div>
    <div class="subgroups" v-if="open && group.subGroups && group.subGroups.length">
      <GroupListItem v-for="item in group.subGroups" :key="item.id" :group="item" @select-open="$emit('select-open', $event)" @select="$emit('select', $event)" :selectedId="selectedId"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { GroupEntity, GroupStatus } from '@/types/catalogs/Groups'
import DateFormat from '@/services/DateFormat'

@Component({
  name: 'GroupListItem'
})
export default class GroupListItem extends Vue {
  @Prop({ required: true })
  group: GroupEntity

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: false })
  opened: boolean

  @Prop({ required: false, default: 0 })
  selectedId: number

  open = false
  groupStatus = GroupStatus

  get creationDate () {
    return this.group.creationDate
      ? new DateFormat(this.group.creationDate).toDateString()
      : '- - / - - / - - - -'
  }

  get updateDate () {
    return this.group.updateDate
      ? new DateFormat(this.group.updateDate).toDateString()
      : '- - / - - / - - - -'
  }

  get title () {
    return this.open ? 'Ocultar subgrupos' : 'Ver subgrupos'
  }

  get isSelected () {
    return this.selectedId === this.group.id
  }

  get titleSelect () {
    return this.isSelected ? 'Clic para deseleccionar' : 'Clic para seleccionar'
  }

  get subGroupsList () {
    return this.group.subGroups && this.group.subGroups.length ? this.group.subGroups.map(g => g.name).join(', ') : ''
  }

  get usersList () {
    return this.group.users && this.group.users.length ? this.group.users.map(g => g.name).join(', ') : ''
  }

  get projectsList () {
    return this.group.projects && this.group.projects.length ? this.group.projects.map(g => g.name).join(', ') : ''
  }

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }
}
</script>

<style lang="scss" scoped>
$blue: #3498db; //- rgb(52,152,219)
$white:    #fff !default;
$gray-100: #f8f9fa !default;
$gray-200: #e9ecef !default;
$gray-300: #dee2e6 !default;
$gray-400: #ced4da !default;
$gray-500: #adb5bd !default;

$primary: $blue;

.group-root {
  margin: 0.5rem 0 0.5rem 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 2px $gray-400;
}
.name {
  position: relative;
  padding: 0.5rem;
  border-radius: inherit;
  padding-left: 1.4rem;
}
.name.root{
  background-color: rgba($color: $gray-200, $alpha: 0.5);
}
.name.selected {
  background-color: rgba($color: $primary, $alpha: 0.4);
  transition-duration: 0.2s;
  box-shadow: 0 0 0 2px $primary;
}
.name:hover{
  box-shadow: 0 0 0 2px $primary;
  transition-duration: 0.2s;
}
.group-title > h6 {
  display: inline-block;
}
.group-title > .status__badge {
  display: block;
  position: absolute;
  width: 3.5rem;
  height: 1rem;
  top: 3.2rem;
  left: calc(0% - 1.3rem);
  transform: rotate(-90deg);
}
.icon-show-details {
  display: inline-block;
  position: absolute;
  margin: 0.75rem 0.2rem;
  top: 0;
  left: 0;
}
.group-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.5rem;
}
.group-details > .group-details__related-recodrs {
  align-self: center;
}
</style>
